module.exports = __webpack_public_path__ + "static/media/smart.858ac516.svg";